import React from 'react'
import useApiService from 'services/api'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { filterStoreRepo } from '../../../../Filters/FilterStore'
import FilterModal from '../../../../Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { CommonFiltersetDoorsAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetDoorsAccountGroup'
import { CommonFiltersetGooglePlaceDoorGroup } from '../../GooglePlaceBase/GooglePlaceDoorBaseTable/CommonFiltersetGooglePlaceDoorGroup'
import { LodgingAmenitiesFilterGroup } from '../../Lodging/LodgingAmenitiesFilterGroup'
import { LODGING_DOORS_COLUMNS } from '../LodgingDoorsColumnsInfo'

export function LodgingDoorsFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = useApiService()
  const { enableLodgingHotelAmenities } = useFeatureFlagService()
  const { data: campaignOptions } = api.useGetCampaignsOptions(
    'lodging-hospitality'
  )

  const lodgingFilterStore = filterStoreRepo.getStore(filterIdentifier)

  return (
    <FilterModal identifier={filterIdentifier} store={lodgingFilterStore}>
      <CommonFiltersetDoorsAccountGroup
        filterStore={lodgingFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <CommonFiltersetGooglePlaceDoorGroup
        filterStore={lodgingFilterStore}
        columns={LODGING_DOORS_COLUMNS}
        companyType="lodging-hospitality"
      />
      {enableLodgingHotelAmenities && (
        <LodgingAmenitiesFilterGroup filterStore={lodgingFilterStore} />
      )}
    </FilterModal>
  )
}
